module.exports = __webpack_public_path__ + "img/10.57a08e55.jpeg";